import EnvironmentConfiguration from "../../../Constants/EnvironmentConfiguration";
import InterestsStep from "../Components/InterestsStep";
import UserSessionContextAreasOfInterestPicker from "./UserSessionContextAreasOfInterestPicker";

/** A provisioned areas of interest picker that is topical to only Body areas of interest. */
const bodyAreasOfInterestPicker: React.FC = () =>
  UserSessionContextAreasOfInterestPicker({
    label: "Body Interests:",
    filter: areaOfInterestOption =>
      areaOfInterestOption.businessUnitId === EnvironmentConfiguration.businessUnitIds.body
  });

/** A provisioned areas of interest picker that is topical to only Contour areas of interest. */
const contourAreasOfInterestPicker: React.FC = () =>
  UserSessionContextAreasOfInterestPicker({
    label: "Contour Interests:",
    filter: areaOfInterestOption =>
      areaOfInterestOption.businessUnitId === EnvironmentConfiguration.businessUnitIds.contour
  });

/** The interests step configured with an areas of interest picker that uses the session context customer's state. */
const ComposedInterestsStep: React.FC = () =>
  InterestsStep({ AreaOfInterestPickers: [bodyAreasOfInterestPicker, contourAreasOfInterestPicker] });

export default ComposedInterestsStep;
